import { combineEpics } from 'redux-observable';
import { createMerchEpic } from './create-merch';
import { getCatalogEpic } from './get-catalog';
import { getCatalogItemEpic } from './get-catalog-item';
import { publishProductEpic } from './publish-product';
import { uploadMerchImageEpic } from './upload-image';
import { takeDownMerchEpic } from './take-down';
import { listArtistMerchEpic } from './list-artist-merch';
import { updateMerchOrderEpic } from './update-merch-order';
import { redirectToMerchPageEpic } from './redirect-merch';
import { redirectToCatalogPageEpic } from './redirect-to-catalog';
import { redirectMerchSuccessPageEpic } from './redirect-merch-success';
import { updateMerchEpic } from './update-merch';
import { editMerchEpic } from './edit-merch';
import { autoSaveMerchEpic } from './autosave';
import { confirmChangeMerchTypeEpic } from './confirm-change-merch-type';
import { showUnavailableMerchEpic } from './show-unavailable-merch';
import { finishMerchLaterEpic } from './finish-merch-later';
import { createSampleOrderEpic } from './create-sample-order';
import { getMerchShippingCostEpic } from './get-merch-shipping-cost';
import { validateMerchProductSampleOrder } from './validate-merch-product-sample-order';
import { getMerchListAfterActivateEpic } from './get-merch-list-after-activate';

const merchEpic = combineEpics(
  getCatalogEpic,
  getCatalogItemEpic,
  uploadMerchImageEpic,
  createMerchEpic,
  updateMerchEpic,
  updateMerchOrderEpic,
  redirectToMerchPageEpic,
  redirectToCatalogPageEpic,
  redirectMerchSuccessPageEpic,
  publishProductEpic,
  takeDownMerchEpic,
  listArtistMerchEpic,
  editMerchEpic,
  autoSaveMerchEpic,
  confirmChangeMerchTypeEpic,
  showUnavailableMerchEpic,
  finishMerchLaterEpic,
  createSampleOrderEpic,
  getMerchShippingCostEpic,
  validateMerchProductSampleOrder,
  getMerchListAfterActivateEpic
);

export default merchEpic;
